<template>
  <div class="q-pa-md">
    <PageHeader
      :title="`Configurar ${namePage}: ${unidade?.nome || ''}`"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 text-brand-5 text-weight-bold q-mt-sm container-btn-acoes"
    >
      <div class="row col-12 q-mb-lg items-center q-gutter-x-md">
        <div>
          <p></p>
          <lista-unidades-select v-model="unidade"></lista-unidades-select>
        </div>

        <div>
          <p></p>
          <q-btn
            label="Tempo Limite de Emissão"
            outline
            style="color: #163a9f"
            no-caps
            dense
            :icon-right="containerTempoLimite ? 'expand_less' : 'expand_more'"
            icon="watch_later"
            class="btn-copiar"
            @click="
              (containerTempoLimite = !containerTempoLimite), (copiar = false)
            "
          />
        </div>

        <div class="column">
          <div class="q-ml-sm titulo-toggle">Geolocalização</div>
          <div class="row items-center q-gutter-x-sm">
            <q-toggle
              class="q-ml-sm toggle"
              v-model="geolocalizacao"
              checked-icon="check"
              :disable="disable"
              color="green"
              unchecked-icon="clear"
              @click="atualizarStatusLocalizacao()"
            />
            <span v-if="geolocalizacao" class="toggle-texto">{{
              "Habilitado"
            }}</span>
            <span v-else class="toggle-texto-red">{{ "Desabilitado" }}</span>
          </div>
        </div>
      </div>
      <div class="row col-12 q-gutter-x-sm input-copiar-tempo">
        <div v-if="copiar" class="col-md-2 col-sm-5 col-xs-5 input-unidade">
          <div class="q-ml-sm titulo-input">Unidade</div>
          <q-select
            dense
            outlined
            class="select"
            v-model="unidade2.nome"
            :options="listaUnidades"
            :option-label="
              (opt) => (Object(opt) === opt && 'nome' in opt ? opt.nome : '')
            "
          />
        </div>
        <span
          v-if="copiar"
          style="margin-top: 30px"
          class="texto-para input-unidade"
          >Para</span
        >
        <div v-if="copiar" class="col-md-2 col-sm-5 col-xs-5 input-unidade">
          <div class="q-ml-sm titulo-input">Unidade</div>
          <q-input
            dense
            disable
            outlined
            class="bg-brand-7 select"
            v-model="unidade.nome"
          />
        </div>
        <div v-if="copiar" class="col-md-2 input-unidade">
          <p></p>
          <q-btn
            class="q-mt-sm btn-copiar-config"
            dense
            color="positive"
            label="Copiar Configurações"
            no-caps
            icon="check_circle_outline"
            @click="verificaDados()"
          />
        </div>
        <div v-if="containerTempoLimite" class="row col-12">
          <div class="col-md-2 col-xs-6 col-sm-6 items-center">
            <q-input
              v-if="editarTempoLimite"
              outlined
              dense
              class="input"
              v-model="tempoLimite"
            ></q-input>
            <div v-else>
              <q-input
                v-if="tempoLimite > 0"
                outlined
                dense
                disable
                bg-color="brand-7"
                class="col-1 input"
                v-model="tempoLimite"
              >
                <template v-slot:append
                  ><span class="absolute text-input-tempo" style="left: 31px">
                    {{ tempoLimite > 1 ? "Horas" : "Hora" }}
                  </span></template
                ></q-input
              >
              <q-input
                bg-color="brand-7"
                disable
                v-else
                outlined
                dense
                class="col-1 input"
              >
                <template v-slot:prepend
                  ><span class="text-input-tempo">{{
                    "Sem limite"
                  }}</span></template
                >
              </q-input>
            </div>
          </div>
          <div
            v-if="!editarTempoLimite"
            class="col-4 q-ml-sm tempo-limite-editar"
          >
            <q-btn
              label="Alterar"
              color="primary"
              icon="edit"
              class="btn q-mt-xs btn-alterar-mobile"
              v-model="tempoLimite"
              dense
              no-caps
              @click="editarTempoLimite = editarTempoLimite = true"
            />
          </div>
          <div
            v-if="editarTempoLimite"
            class="col-4 q-ml-sm tempo-limite-enviar"
          >
            <q-btn
              label="Enviar"
              color="positive"
              icon="check_circle_outline"
              class="btn q-mt-xs"
              v-model="tempoLimite"
              dense
              no-caps
              @click="adicionarConfiguração()"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row col-12 q-mt-xl container-btn">
      <div class="q-mr-sm">
        <q-btn
          color="brand-8"
          label="Criação de Modelo"
          no-caps
          class="btn"
          :outline="modeloAtivo"
          dense
          icon="view_module"
          @click="modelos()"
        />
      </div>
      <div class="q-mr-sm">
        <q-btn
          color="brand-1"
          label="Atividades"
          no-caps
          class="btn"
          :outline="ativiAtivo"
          dense
          icon="settings"
          @click="atividades()"
        />
      </div>
      <div class="q-mr-sm">
        <q-btn
          color="red-8"
          label="Responsáveis"
          no-caps
          class="btn"
          :outline="respAtivo"
          dense
          icon="supervisor_account"
          @click="responsaveis()"
        />
      </div>
      <div class="q-mr-sm">
        <q-btn
          color="brand-5"
          label="Informações"
          no-caps
          class="btn"
          :outline="infoAtivo"
          dense
          icon="person"
          @click="informacoes()"
        />
      </div>
      <div>
        <q-btn
          color="positive"
          label="Encerramento"
          no-caps
          class="btn btn-encerramento"
          :outline="encerraAtivo"
          dense
          icon="assignment_turned_in"
          @click="encerramento()"
        />
      </div>
    </div>
    <q-dialog v-model="confirm">
      <q-card
        class="column justify-between"
        style="width: 700px; height: 300px"
      >
        <q-card-section class="row items-center">
          <span style="font-size: 17px" class="q-ml-sm"
            >Deseja realmente substituir as configurações da
            {{ unidade.nome }} ?</span
          >
          <span
            style="font-size: 13px"
            class="q-ml-sm q-mt-md text-brand-5 text-weight-bold"
            ><strong>Observação:</strong> Ao confirmar, todos os dados da
            {{ unidade.nome }} serão sobreescritos pela
            {{ unidade2.nome.nome }}.
          </span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            no-caps
            icon="cancel"
            label="Cancelar"
            color="negative"
            v-close-popup
          />
          <q-btn
            label="Confirmar"
            color="positive"
            v-close-popup
            no-caps
            icon="check_circle_outline"
            @click="copiarDados()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <router-view class="q-mt-lg"></router-view>
  </div>
</template>

<script>
import { onMounted, watch, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: { ListaUnidadesSelect, PageHeader },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const unidade = ref("");
    const quasar = useQuasar();
    const unidadeDetalhe = ref();
    const liberar = ref(true);
    const enviar = ref(0);
    let copiar = ref(false);
    let respAtivo = ref(true);
    let infoAtivo = ref(true);
    let encerraAtivo = ref(true);
    let ativiAtivo = ref(true);
    let modeloAtivo = ref(true);
    let confirm = ref(false);
    let unidade2 = ref({
      nome: "",
    });
    let namePage = ref();
    let editarTempoLimite = ref(false);
    const listaUnidades = ref([]);
    let geolocalizacao = ref();
    const tempoLimite = ref("");
    let containerTempoLimite = ref(false);
    let disable = ref(false);

    let listarUnidades = async () => {
      try {
        let resposta = await store.dispatch("org/listarUnidades");

        listaUnidades.value = resposta.listaUnidades;
      } catch (error) {
        console.error(error);
      }
    };

    const copiarDados = async () => {
      try {
        await store.dispatch("pdt/copiarConfiguracoes", {
          recebe: unidade.value.id,
          envia: unidade2.value.nome.id,
        });
        quasar.notify({
          message: "Configurações copiadas",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        atividades();
        copiar.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro ao copiar as configurações",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        console.log(error);
      }
    };

    const verificaRota = () => {
      if (route.name == "pdt-informacoes") {
        infoAtivo.value = false;
        respAtivo.value = true;
        ativiAtivo.value = true;
        encerraAtivo.value = true;
        modeloAtivo.value = true;
        namePage.value = "Informações";
        return;
      }
      if (route.name == "pdt-atividades-unidade") {
        infoAtivo.value = true;
        respAtivo.value = true;
        ativiAtivo.value = false;
        encerraAtivo.value = true;
        modeloAtivo.value = true;
        namePage.value = "Atividades";
        return;
      }
      if (route.name == "pdt-tipo-responsaveis") {
        infoAtivo.value = true;
        respAtivo.value = false;
        ativiAtivo.value = true;
        encerraAtivo.value = true;
        modeloAtivo.value = true;
        namePage.value = "Responsáveis";
        return;
      }
      if (route.name == "pdt-encerramento") {
        infoAtivo.value = true;
        respAtivo.value = true;
        ativiAtivo.value = true;
        encerraAtivo.value = false;
        modeloAtivo.value = true;
        namePage.value = "Encerramento";
        return;
      }
      if (route.name == "pdt-modelos") {
        infoAtivo.value = true;
        respAtivo.value = true;
        ativiAtivo.value = true;
        encerraAtivo.value = true;
        modeloAtivo.value = false;
        namePage.value = "Criação de Modelo";
        return;
      }
    };

    const verificaDados = () => {
      if (!unidade2.value.nome.id || !unidade.value.id) {
        quasar.notify({
          message: "Selecione a unidade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (unidade2.value.nome.id == unidade.value.id) {
        quasar.notify({
          message: "As unidades não podem ser iguais",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      confirm.value = true;
    };

    const checarStatusLocalizacao = async () => {
      let resposta = await store.dispatch("pdt/checarStatusGeolocalizacao", {
        unidadeId: unidade.value.id,
      });
      geolocalizacao.value = resposta.data.resultado.ativo;
    };

    const atualizarStatusLocalizacao = async () => {
      disable.value = true;
      await store.dispatch("pdt/atualizarStatusLocalizacao", {
        unidadeId: unidade.value.id,
        ativo: geolocalizacao.value,
      });
      disable.value = false;
      checarStatusLocalizacao();
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value = store.state.org.unidadeData;
        listarUnidades();
        checarStatusLocalizacao();
      }
    );

    watch(
      () => route.name,
      () => {
        verificaRota();
      }
    );

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidade.value = store.state.org.unidadeData;
      checarStatusLocalizacao();
    };

    const informacoes = () => {
      router.push({ name: "pdt-informacoes" });
    };

    const encerramento = () => {
      router.push({ name: "pdt-encerramento" });
    };

    const responsaveis = () => {
      router.push({ name: "pdt-tipo-responsaveis" });
    };

    const atividades = () => {
      router.push({ name: "pdt-atividades-unidade" });
    };

    const modelos = () => {
      router.push({ name: "pdt-modelos" });
    };

    const listarConfiguracoesDeUnidade = async () => {
      await unidade.value.id;
      try {
        let response = await store.dispatch("pdt/listarConfiguracaoGeral", {
          unidadeId: unidade.value.id,
        });
        if (response.data.resultado.dados) {
          tempoLimite.value = response.data.resultado.dados[0].valor;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const adicionarConfiguração = async () => {
      try {
        await store.dispatch("pdt/adicionarConfiguracaoGeral", {
          unidadeId: unidade.value.id,
          tipo: "prazoLimitePt",
          valor: tempoLimite.value,
        });
        quasar.notify({
          message: "Tempo limite para emissão de PTs alterado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        editarTempoLimite.value = false;
        listarConfiguracoesDeUnidade();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao alterar tempo limite",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getUnidadee = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidadee);
    onMounted(getUnidade);
    onMounted(listarUnidades);
    onMounted(verificaRota);
    onMounted(listarConfiguracoesDeUnidade);

    return {
      unidade,
      getUnidade,
      unidadeDetalhe,
      liberar,
      enviar,
      informacoes,
      encerramento,
      responsaveis,
      atividades,
      modelos,
      respAtivo,
      infoAtivo,
      encerraAtivo,
      ativiAtivo,
      modeloAtivo,
      verificaRota,
      namePage,
      unidade2,
      listaUnidades,
      listarUnidades,
      copiarDados,
      confirm,
      verificaDados,
      geolocalizacao,
      atualizarStatusLocalizacao,
      copiar,
      listarConfiguracoesDeUnidade,
      adicionarConfiguração,
      tempoLimite,
      editarTempoLimite,
      disable,
      containerTempoLimite,
    };
  },
};
</script>

<style scoped>
.container-btn {
  margin: 35px 0px 0px 0px;
  padding: 0px;
}
.input-unidade {
  margin-bottom: 19px;
}
.toggle-texto {
  color: #58c16d;
}
.toggle-texto-red {
  color: red;
}
.container-toggle {
  margin: 50px 0px 30px 0px;
}
.text-input-tempo {
  font-size: 14px;
  font-weight: bold;
  color: #707070;
}
.btn-copiar-config {
  margin-left: 14px;
}
.tempo-limite-editar {
  margin: 0px 0px 0px 15px;
}
.tempo-limite-enviar {
  margin: 0px 0px 0px 15px;
}
@media (max-width: 600px) {
  .container-btn-acoes {
    margin: 0px;
  }
  .input-copiar-tempo {
    margin-top: 0px;
  }
  .text-input-tempo {
    font-size: 12px;
    font-weight: bold;
    color: #707070;
  }
  .titulo-pagina {
    font-size: 14px;
  }
  .btn-copiar {
    font-size: 12px;
  }
  .titulo-input {
    margin: 0px;
    font-size: 12px;
  }
  .texto-para {
    font-size: 10px;
  }
  .select {
    font-size: 10px;
  }
  .btn-copiar-config {
    font-size: 11px;
    margin-left: 0px;
  }
  .container-btn {
    margin: 20px 0px;
    padding: 0px;
  }
  .btn {
    font-size: 12px;
    border-radius: 2px;
  }
  .btn-encerramento {
    margin-top: 10px;
  }
  .container-toggle {
    margin: 30px 0px 30px 0px;
  }
  .toggle {
    margin: 0px;
  }
  .titulo-toggle {
    font-size: 12px;
  }
  .toggle-texto {
    font-size: 10px;
    margin: 0px;
    color: #58c16d;
  }
  .toggle-texto-red {
    font-size: 10px;
    margin: 0px;
    color: red;
  }
  .input-unidade {
    margin-bottom: 8px;
  }

  .input {
    font-size: 11px;
  }
}
@media (max-width: 500px) {
  .tempo-limite-editar {
    margin: 2px 0px 0px 15px;
  }
  .tempo-limite-enviar {
    margin: 2px 0px 0px 15px;
  }
}
@media (max-width: 480px) {
  .container-btn-acoes {
    margin: 0px;
  }
  .input-copiar-tempo {
    margin-top: 0px;
  }
  .text-input-tempo {
    font-size: 12px;
    font-weight: bold;
    color: #707070;
  }
  .titulo-pagina {
    font-size: 14px;
  }

  /* Aumentar ambos os botões principais para ficarem igual ao input Unidade */
  .container-btn-acoes
    .row.col-12.q-mb-lg.items-center.q-gutter-x-md
    > div:first-child
    .btn-copiar,
  .container-btn-acoes
    .row.col-12.q-mb-lg.items-center.q-gutter-x-md
    > div:nth-child(2)
    .btn-copiar {
    font-size: 12px !important;
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 8px !important;
    min-height: 40px !important;
    height: 40px !important;
    padding: 8px 16px !important;
  }

  /* Organizar os primeiros elementos em coluna para mobile */
  .container-btn-acoes .row.col-12.q-mb-lg.items-center.q-gutter-x-md {
    display: flex !important;
    flex-direction: column !important;
    gap: 8px !important;
  }

  .container-btn-acoes .row.col-12.q-mb-lg.items-center.q-gutter-x-md > div {
    width: 100% !important;
  }

  .titulo-input {
    margin: 0px;
    font-size: 12px;
  }
  .texto-para {
    font-size: 10px;
  }
  .select {
    font-size: 10px;
  }
  .btn-copiar-config {
    font-size: 11px;
    margin-left: 0px;
  }

  /* Container dos botões organizados em duas linhas */
  .container-btn {
    margin: 20px 0px;
    padding: 0px;
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 8px !important;
  }

  /* Botões em duas linhas - 2 por linha */
  .container-btn > div {
    flex: 0 0 calc(50% - 4px) !important;
    margin-right: 0 !important;
  }

  .btn {
    font-size: 12px !important;
    border-radius: 2px !important;
    width: 100% !important;
    min-height: 40px !important;
  }

  .btn-encerramento {
    margin-top: 0px !important;
  }

  .container-toggle {
    margin: 30px 0px 30px 0px;
  }
  .toggle {
    margin: 0px;
  }
  .titulo-toggle {
    font-size: 12px;
  }
  .toggle-texto {
    font-size: 10px;
    margin: 0px;
    color: #58c16d;
  }
  .toggle-texto-red {
    font-size: 10px;
    margin: 0px;
    color: red;
  }
  .input-unidade {
    margin-bottom: 8px;
  }

  .input {
    font-size: 11px;
  }

  .tempo-limite-editar {
    margin: 2px 0px 0px 15px;
  }
  .tempo-limite-enviar {
    margin: 2px 0px 0px 15px;
  }

  /* Correção para o botão de excluir vermelho nos cards */
  .q-btn.bg-red,
  .q-btn.text-red,
  .q-btn[style*="background: #cf1515"],
  .q-btn[style*="background-color: red"],
  .q-btn.q-btn--outline.text-red {
    min-height: 40px !important;
    width: 100% !important;
    font-size: 12px !important;
  }
  .btn-alterar-mobile {
    margin-top: -3px;
  }
}
</style>
